import { CONFIG_SET, CHANGE_FILTER } from "../constants/actionTypes";
import { ConfigAction, ConfigState } from "../types/config";

const initialState: ConfigState = {
  config: {
    tposFilters: [],
    nutritionalInformationTranslations: {},
    featureFlags: {
      enablePickupOrders: false,
      enableHeroSection: false,
      enableGroupOrdering: false,
      enableLaunchPopup: false,
      enablePickupInDriveThru: false,
    },
    aggregators: [],
  },
};

const applySetConfig = (
  state: ConfigState,
  { payload }: { payload: ConfigState["config"] },
): ConfigState => ({
  ...state,
  config: payload,
});

const applyChangeFilter = (
  state: ConfigState,
  { payload }: { payload: string },
): ConfigState => ({
  ...state,
  selectedFilter: payload,
});

const configReducer = (
  state: ConfigState = initialState,
  action: ConfigAction,
) => {
  switch (action.type) {
    case CONFIG_SET:
      return applySetConfig(state, action);
    case CHANGE_FILTER:
      return applyChangeFilter(state, action);
    default:
      return state;
  }
};
export default configReducer;
